import type { CSSProperties } from "react";

export type MarkProps = {
  size?: number;
  withWordmark?: boolean;
  className?: string;
  style?: CSSProperties;
};

export function Mark({ size = 32, withWordmark = false, className, style }: MarkProps) {
  return (
    <span
      className={className}
      style={{ display: "inline-flex", alignItems: "center", gap: 10, ...style }}
    >
      <img
        src={`${import.meta.env.BASE_URL}mark.png`}
        alt=""
        aria-hidden
        width={size}
        height={size}
        style={{
          display: "block",
          borderRadius: size * 0.22,
          boxShadow: "0 1px 2px rgba(15, 23, 42, 0.08)",
        }}
      />
      {withWordmark && (
        <span
          style={{
            fontFamily: "var(--font-display)",
            fontWeight: 600,
            letterSpacing: "-0.01em",
            fontSize: size * 0.5,
            color: "var(--label-primary)",
          }}
        >
          SquaredIoT
        </span>
      )}
    </span>
  );
}
